import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{
        background: "linear-gradient(to bottom right, #EAF6FF, #DCEFFF, #F8FAFC)",
      }}
    >
      {/* Tarjeta principal */}
      <div className="
        bg-white/60 backdrop-blur-xl
        rounded-3xl 
        shadow-[0_18px_50px_-15px_rgba(58,106,255,0.35)]
        ring-1 ring-blue-100 
        px-10 py-12 max-w-lg
      ">
        <h1 className="text-7xl font-extrabold text-[#3A6AFF] drop-shadow mb-4">
          404
        </h1>

        <h2 className="text-2xl font-bold text-[#0A1440] mb-3">
          Página no encontrada
        </h2>

        <p classname="text-gray-700 text-base mb-8">
          Parece que esta página no existe o fue movida.  
          Puedes volver al inicio haciendo clic abajo.
        </p>

        <button
          onClick={() => navigate("/")}
          className="
            bg-[#3A6AFF] hover:bg-blue-700 
            text-white font-semibold 
            px-6 py-3 rounded-xl transition
          "
        >
          Volver al inicio
        </button>
      </div>
    </div>
  );
};

export default NotFound;
